import { staticUrls } from './StaticUrls';

export const FACILITY_DEFAULT_IMAGES = [
  staticUrls.daycareDefault1,
  staticUrls.daycareDefault2,
  staticUrls.daycareDefault3,
  staticUrls.daycareDefault4,
  staticUrls.daycareDefault5,
  staticUrls.daycareDefault6,
];

export const getRandomFacilityDefaultImageUrl = (): string => FACILITY_DEFAULT_IMAGES[Math.floor(Math.random() * FACILITY_DEFAULT_IMAGES.length)];
